import { lazyRouteComponent } from '@tanstack/react-router';
import { Truck } from 'lucide-react';
import type { WebModule } from '../web-module.ts';

/** Módulo Fornecedores nas telas (catálogo beadev-ai/catalogo). Os textos ficam em `suppliers.*`. */
export const webModule: WebModule = {
  id: 'suppliers',
  areas: [
    {
      id: 'suppliers',
      key: 'suppliers.area',
      icon: Truck,
      groups: [
        {
          key: null,
          items: [
            {
              to: '/suppliers',
              key: 'suppliers.nav.list',
              icon: Truck,
              permission: ['suppliers.supplier.read', 'suppliers.supplier.manage'],
            },
          ],
        },
      ],
    },
  ],
  routes: [
    {
      path: '/suppliers',
      component: lazyRouteComponent(() => import('./SuppliersPage.tsx'), 'SuppliersPage'),
    },
  ],
  permissionAreas: [
    {
      id: 'suppliers',
      key: 'suppliers.area',
      processes: [
        {
          id: 'suppliers',
          key: 'suppliers.process',
          permissions: ['suppliers.supplier.read', 'suppliers.supplier.manage'],
        },
      ],
    },
  ],
};
